import clipboard from '@ps-int/ufo-rocks/lib/helpers/clipboard';

export const copy = async (message: string, useRange?: boolean) => {
    let isSuccess = false;
    let method: 'execCommand' | 'writeText' = 'writeText';

    try {
        await navigator.clipboard.writeText(message);
        isSuccess = true;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log('navigator.clipboard.writeText error', error);
        isSuccess = clipboard.copy(message, useRange);
        if (isSuccess) {
            method = 'execCommand';
        }
    }

    if (isSuccess) {
        // eslint-disable-next-line no-console
        console.log(`Копирование произведено успешно с помощью ${method}`);
    } else {
        // eslint-disable-next-line no-console
        console.warn('Не удалось выполнить копирование');
    }

    return isSuccess;
};
